export default __webpack_public_path__ + "static/media/success.b7635612.svg";